// Primeira tela, sem sessão: entrar com Google (toda pessoa joga com conta) ou ir direto para uma sala pelo código. No
// computador, duas metades: a marca, a chamada e as cartas à esquerda; o login à direita.
import { useState } from 'react';
import { NOME_DO_PLANO } from '@truco6/planos';
import { destinoGuardado } from '../comum/chegada.ts';
import { conta } from '../comum/conta.ts';
import { indicacaoGuardada } from '../comum/indicacao.ts';
import { medir } from '../comum/medicao.ts';
import { ir } from '../comum/rotas.ts';
import { imagemDaCarta } from '@truco6/ui';
import { Marca } from '@truco6/ui/Marca';
import { CampoCodigo, Tela } from './comum.tsx';

export function Entrada() {
  const [erro, setErro] = useState<string | null>(null);
  const [convidado] = useState(() => indicacaoGuardada() !== null);
  const [destino] = useState(destinoGuardado);
  return (
    <Tela>
      <div className="tela-entrada">
      <div className="entrada-chamada">
      <Marca altura={48} />
      {convidado && <p className="convite-amigo" role="status">Um amigo te chamou para a mesa. Crie sua conta com Google e ele ganha partidas bônus.</p>}
      <div className="chamada">
        <h1>Bora pra mesa</h1>
        <p className="sub">Truco paulista de 6, em trios. Chame a turma pelo link e jogue no celular ou no computador.</p>
      </div>
      {/* Só no computador: as três maiores manilhas, abertas em leque. */}
      <div className="leque-entrada" aria-hidden="true">
        {['4s', '4h', '4c'].map((id) => <img key={id} src={imagemDaCarta(id)} alt="" width={132} height={185} />)}
      </div>
      </div>
      <div className="entrada-login">
      {destino?.tela === 'assinar' && (
        <p className="convite-amigo" role="status">Para assinar o {NOME_DO_PLANO[destino.plano]}, entre com Google. Na volta, é só confirmar.</p>
      )}
      <button className="google" onClick={() => { medir('login', { method: 'google' }); conta.entrarComGoogle(location.origin + '/').catch((e: Error) => setErro(e.message)); }}>
        <LogoGoogle />Entrar com Google
      </button>
      <p className="nota apoio-entrada">Cadastro rápido. Você joga 2 partidas grátis por dia e ganha +5 a cada amigo que chamar.</p>
      {erro && <p className="erro" role="alert">{erro}</p>}
      <div className="ou"><span>ou</span></div>
      <CampoCodigo rotulo="Tem o código da sala?" aoEntrar={(codigo) => ir({ tela: 'sala', codigo })} />
      <p className="nota">Para maiores de 18 anos. Sem dinheiro real em jogo.</p>
      <p className="nota links-legais">Ao entrar, você aceita os <a href="/termos">Termos de uso</a> e a <a href="/privacidade">Política de privacidade</a>.</p>
      </div>
      </div>
    </Tela>
  );
}

export function LogoGoogle() {
  return (
    <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.6 5.4 2.6 13.2l7.9 6.2C12.4 13.7 17.7 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.1 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.4c-.5 2.9-2.2 5.3-4.6 6.9l7.4 5.8c4.3-4 6.9-9.9 6.9-17.2z" />
      <path fill="#FBBC05" d="M10.5 28.6c-.5-1.4-.8-3-.8-4.6s.3-3.2.8-4.6l-7.9-6.2C.9 16.6 0 20.2 0 24s.9 7.4 2.6 10.8l7.9-6.2z" />
      <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.4-5.8c-2.1 1.4-4.8 2.3-8.5 2.3-6.3 0-11.6-4.2-13.5-10l-7.9 6.2C6.6 42.6 14.6 48 24 48z" />
    </svg>
  );
}
